import React from 'react';
import { useQuery } from 'react-query';
import { getDeviceValues } from '../api/homepage';
import { useHomePageSignalR } from '../hooks/useHomePageSignalR';
import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { format } from 'date-fns';

const HomePage = () => {
  const signalRData = useHomePageSignalR();
  const { data: deviceValues } = useQuery('deviceValues', getDeviceValues, {
    enabled: true,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const finalData = signalRData.length > 0 ? signalRData : deviceValues;

  const formatTime = dateString => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy HH:mm:ss');
    } catch (error) {
      console.warn(`⚠️ Geçersiz tarih formatı: ${dateString}`, error);
      return 'Invalid date';
    }
  };

  const getValueColor = value => {
    const lowerCaseValue = String(value).toLowerCase();
    return lowerCaseValue === 'na' ||
      lowerCaseValue === 'n/a' ||
      lowerCaseValue === 'error'
      ? 'red'
      : 'black';
  };

  return (
    <div style={{ display: 'flex' }}>
      {finalData?.map((group, index) => (
        <div
          key={index}
          style={{
            marginRight: '20px',
            border: '1px solid #ccc',
            padding: '10px',
            borderRadius: '8px',
          }}
        >
          <h2
            style={{
              fontWeight: 'bold',
              marginBottom: '10px',
              fontSize: '16px',
              borderBottom: '1px solid #ccc',
            }}
          >
            {group.groupName}
          </h2>
          <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <Table size="sm" variant="simple" colorScheme="gray">
              <Thead>
                <Tr>
                  <Th>Time</Th>
                  <Th>Name</Th>
                  <Th>Value</Th>
                  <Th>Unit</Th>
                </Tr>
              </Thead>
              <Tbody>
                {group.values.map((value, valueIndex) => (
                  <Tr key={`${index}-${valueIndex}`}>
                    <Td>{value.time ? formatTime(value.time) : 'N/A'}</Td>
                    <Td>{value.name}</Td>
                    <Td style={{ color: getValueColor(value.value) }}>
                      {value.value}
                    </Td>
                    <Td>{value.unit}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomePage;
